/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { OptimizedCosmosAssetFragment } from "@components/elements/atoms";

// This allows fragments to add an optUrl alias which transforms Asset's url field to the desired width
// For example, to request 740px-wide images, you'd create your fragment like this:
//
// fragment MyComponentFragment on CosmosElementMyComponent {
//     asset {
//         ...CosmosAsset
//         optUrl: url(transformation: { image: { resize: { width: 740 } } })
//     }
// }
export const getOptAsset = (
	asset?: OptimizedCosmosAssetFragment | null,
): OptimizedCosmosAssetFragment | null | undefined => {
	if (!asset) return asset;
	if (!asset.optUrl) return asset;
	return { ...asset, url: asset.optUrl || asset.url };
};
